import { ParticipationEventState } from "@Interfaces";

/**
 * Fire-and-forget usage telemetry for the Participation tab: whether
 * organizers actually open it during their events. Calls never throw and
 * return nothing, so callers can't break the UI or forget a try/catch.
 *
 * TODO(BE-1): every call is still a stub; nothing is sent until tb-backend
 * has a usage-reporting endpoint. Swap each stub for the real request then.
 */

// Telemetry failures are never user-facing.
const send = (request: () => Promise<unknown>): void => {
    request().catch(() => undefined);
};

export const ParticipationUsageService = {
    reportTabOpened: (
        channelId: string,
        state: ParticipationEventState
    ): void =>
        send(async () => {
            // TODO(BE-1): e.g.
            // Http.Request<void>({
            //     method: "POST",
            //     url: `/groups/${channelId}/participation/usage/tab-opened`,
            //     data: { state },
            // });
        }),

    reportAttendeeCountChanged: (
        channelId: string,
        count: number,
        previousCount: number | null
    ): void =>
        send(async () => {
            // TODO(BE-1): e.g.
            // Http.Request<void>({
            //     method: "POST",
            //     url: `/groups/${channelId}/participation/usage/attendee-count-changed`,
            //     data: { count, previous_count: previousCount },
            // });
        }),

    /** Seconds on screen since the previous report; the backend adds them up. */
    reportVisibleDuration: (channelId: string, durationSeconds: number): void =>
        send(async () => {
            // TODO(BE-1): this may run while the page is closing, when axios
            // requests are cancelled. Use a keepalive fetch with the same token:
            // fetch(`/v1/groups/${channelId}/participation/usage/visible-duration`, {
            //     method: "POST",
            //     keepalive: true,
            //     headers: {
            //         "Content-Type": "application/json",
            //         Authorization: String(api.defaults.headers.common.Authorization),
            //     },
            //     body: JSON.stringify({ duration_seconds: durationSeconds }),
            // });
        }),
};
